import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, Event, NavigationStart, NavigationError } from '@angular/router';
import { AppStateService } from '../../services/app-state.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  heading = '';
  scrollPoniter = false;
  activeCat = '';
  categoryData = {};
  mode: ProgressSpinnerMode = 'determinate';
  color: '#ffff';
  value = 70;
  score = 0;

  constructor(private router: Router, private appStateService: AppStateService) {
    this.appStateService.getActiveCategory().subscribe(val => {
      this.activeCat = val;
    });
    this.appStateService.getCategoriesData().subscribe(val => {
      this.categoryData = val;
    });
    this.appStateService.getResult().subscribe(result => {
      this.score = result.score;
    })

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        console.log(event);
        if (event.url.indexOf('/pages/result') > -1) {
          this.heading = 'resultPage';
          this.scrollPoniter = true;
          console.log(this.heading)
        }

        else {
          this.scrollPoniter = false;
        }


      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });
  }

  ngOnInit(): void {
  }

}
